var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bd",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006a4e",
    d: "M0 0h640v480H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 240,
    r: 160,
    fill: "#f42a41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBd);
export default __webpack_public_path__ + "static/media/bd.0ad8c443.svg";
export { ForwardRef as ReactComponent };